import { useEffect } from 'react';

export const onScroll = (nodeId, height) => {
  const node = document.getElementById(nodeId);
  if (node === null) {
    return;
  }

  node.classList.add('last-price__act');

  // const trackScroll = () => {
  //   const scroll = window.scrollY;

  //   if (scroll >= height) {
  //     node.classList.add('last-price__act');
  //   } else {
  //     node.classList.remove('last-price__act');
  //   }
  // };

  // window.addEventListener('scroll', trackScroll);
};

const ToCartFixed = ({ inCart, onClick }) => {
  useEffect(() => onScroll('scrollup', 200), []);

  return (
    <div className="last-price__mob" id="scrollup">
      <div className="last-price__first">
        {!inCart && (
          <button className="btn" onClick={onClick}>
            <span>Добавить в корзину</span>
          </button>
        )}
        {inCart && (
          <button
            className="btn in-cart"
            onClick={() => (window.location.href = '/cart')}
          >
            <span>В корзине</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default ToCartFixed;
